import { Fragment, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import UseDevicePixelRatio from '../../../../common/hooks/useDevicePixelRatio'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { changeViews, selectViews } from '../store/slice'
import { selectScreeningIndicatorById } from './../../common/store/slice'
import { DefaultInfo } from './DefaultInfo'
import classes from './index.module.scss'

export const AdditionalInfo = () => {
  const dispatch = useDispatch()

  const devicePixelRatio = UseDevicePixelRatio()
  const screeningIndicatorById = useSelector(selectScreeningIndicatorById())
  const viewsData = useSelector(selectViews)

  const [dragOverIndex, setDragOverIndex] = useState(null)

  const draggedIndexRef = useRef()

  const data = viewsData
    .filter(
      (item, index) =>
        viewsData.findIndex((view) => view.groupId === item.groupId) === index,
    )
    .map((item) => ({
      ...item,
      ...screeningIndicatorById[item.screeningIndicatorId],
    }))

  const handleSortViews = (newData) => {
    const newViewsData = JSON.parse(JSON.stringify(newData))

    viewsData.forEach((view) => {
      if (
        !newViewsData.find(
          (item) =>
            item.screeningIndicatorId === view.screeningIndicatorId &&
            view.year === item.year,
        )
      ) {
        const lastGroupIndex = newViewsData.findLastIndex(
          (item) => item.groupId === view.groupId,
        )
        if (lastGroupIndex !== -1) {
          newViewsData.splice(lastGroupIndex + 1, 0, view)
        }
      }
    })

    dispatch(
      changeViews(
        newViewsData.map((item) => ({
          screeningIndicatorId: item.screeningIndicatorId,
          year: item.year,
          groupId: item.groupId,
        })),
      ),
    )
  }

  const onDragStart = (e, index) => {
    draggedIndexRef.current = index
    e.dataTransfer.effectAllowed = 'move'
  }

  const onDragEnter = (e, index) => {
    e.preventDefault()
    e.dataTransfer.dropEffect = 'move'
    setDragOverIndex(index)
  }

  const onDragOver = (e, index) => {
    e.preventDefault()
    e.dataTransfer.dropEffect = 'move'
    const elementDomRect = e.target.getBoundingClientRect()
    const breakpointY = (elementDomRect.bottom + elementDomRect.top) / 2
    setDragOverIndex(
      e.clientY * devicePixelRatio > breakpointY ? index + 1 : index,
    )
  }

  const onDragEnd = () => {
    const draggedIndex = draggedIndexRef.current

    const newData = JSON.parse(JSON.stringify(data))

    if (draggedIndex < dragOverIndex - 1) {
      newData.splice(dragOverIndex, 0, data[draggedIndex])
      newData.splice(draggedIndex, 1)
      handleSortViews(newData)
    }

    if (draggedIndex > dragOverIndex) {
      const [draggedItem] = newData.splice(draggedIndex, 1)
      newData.splice(dragOverIndex, 0, draggedItem)
      handleSortViews(newData)
    }

    draggedIndexRef.current = null
    setDragOverIndex(null)
  }

  const handleDelete = (item) => {
    const newViewsData = viewsData.filter(
      ({ groupId }) => groupId !== item.groupId,
    )
    dispatch(changeViews(newViewsData))
  }

  return (
    <Element className={classes.additionalInfo}>
      <ScrollComponent>
        <div className="pb1" />
        <DefaultInfo />
        <Element>
          {data.map((item, index) => (
            <Fragment key={`${item.screeningIndicatorId}-${item.year}`}>
              <DropBar
                onDragEnter={(e) => onDragEnter(e, index)}
                index={index}
                dragOverIndex={dragOverIndex}
              />
              <Element
                className={`${classes.infoItem}`}
                style={{ borderColor: '#D5D5D5' }}
                draggable
                onDragStart={(e) => onDragStart(e, index)}
                onDragEnd={onDragEnd}
                onDragOver={(e) => onDragOver(e, index)}
              >
                <Icon
                  className="icon-menu"
                  style={{ color: '#9C9C9C', fontSize: 10 }}
                />
                <Element elementName="span" className="flex1 fw600">
                  {item.screeningIndicatorName} - {item.year}
                </Element>
                <Icon
                  className="icon-delete"
                  style={{ color: '#9C9C9C', fontSize: 11 }}
                  onClick={() => handleDelete(item)}
                />
              </Element>
              {index === data.length - 1 && (
                <DropBar
                  onDragEnter={(e) => onDragEnter(e, data.length)}
                  index={data.length}
                  dragOverIndex={dragOverIndex}
                />
              )}
            </Fragment>
          ))}
        </Element>
      </ScrollComponent>
    </Element>
  )
}

const DropBar = ({ onDragEnter, index, dragOverIndex }) => {
  return (
    <Element
      onDragEnter={onDragEnter}
      className={classes.dropBar}
      style={{
        backgroundColor: dragOverIndex === index ? '#2C73E8' : '',
      }}
    />
  )
}
